import API from "@/api/lib/api";

export const getAllNotice = async (restaurant_id) => {
  try {
    const response = await API.get(`online-order/settings/restaurant/${restaurant_id}/notices`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleNotice = async (item_id) => {
  try {
    const response = await API.get(`online-order/settings/notices/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createNotice = async (data) => {  
  try {
    const response = await API.post(`online-order/settings/notices`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating notice:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};

export const updateNotice = async (item_id, data) => {
  try {
    const response = await API.put(`online-order/settings/notices/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleNotice = async (id) => {
  try {
    const response = await API.put(`online-order/settings/notices/${id}/toggle`);
    return response.data;
  } catch (error) {    
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteNotice = async (item_id) => {
  try {
    const response = await API.delete(`online-order/settings/notices/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
